import decorator from 'lib/lang/decorator';
import type {Form} from 'lib/form/form';
import {PhotoFileFieldData} from './photofile-field-data';


export default decorator(({type, fieldName = 'images'} = {}) => (Class: typeof Form) => {
    class PhotoFileForm extends Class {
        constructor(options) {
            super(options);

            const {photoFileStore} = options;

            this.photoFileStore = photoFileStore;
            const next = this.handleSubmit;

            this.handleSubmit = (...args) => {
                const promises = [];

                this.field.get(fieldName).data.fields.forEach((fieldData) => {
                    if (fieldData.cropperDescriptorData.dirty) {
                        const photoFile = fieldData.value;
                        const cropperDescriptor = fieldData.cropperDescriptorData.value;

                        promises.push(photoFile.saveCropperDescriptor({
                            cropperDescriptor,
                        }));
                    }
                });

                return Promise.all(promises).then(() => next(...args));
            };

        }

        photoFileFieldDataForFiles = ({files}) => files.map(file => new PhotoFileFieldData({
            file,
            type,
            photoFileStore: this.photoFileStore,
        }));

    }

    return PhotoFileForm;
});

